export default function removeEmptyImg() {
    const images = document.querySelectorAll("img");
    images.forEach((img) => {
        if (!img.getAttribute('src')) {
            img.setAttribute('hidden', true);
            img.setAttribute('noSource', true);
        }
    });
}
